import React, { useState } from 'react';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import queryString from 'qs';

const Tabs = (props) => {
  const [isOpen, setIsOpen] = useState(
    typeof window !== 'undefined' &&
      window.matchMedia('(min-width: 1025px)').matches
  );

  function handleToggle() {
    setIsOpen(!isOpen);
  }

  const { Tabs, location, Id } = props;

  if (!Tabs) return null;
  const options = {
    ignoreQueryPrefix: true,
  };
  const q = props.TypeExists ? queryString.parse(location.search, options) : '';

  let currentTab = null;

  const tabs = Tabs.map((tab, index) => {
    const tabQ = queryString.parse(tab.Url);
    const current = !q.t ? index === 0 : q.t === tabQ.t;
    const classes = classNames({
      'c-tabs__nav__item': true,
      'c-tabs__nav__item--selected': current,
    });

    if (current) currentTab = tab;

    return (
      <li key={index} className={classes}>
        <a href={tab.Url}>{tab.Name}</a>
      </li>
    );
  });

  const tabsClasses = classNames({
    'c-tabs': true,
    'c-tabs--is-open': isOpen,
  });

  return (
    <nav className={tabsClasses}>
      <div onClick={() => handleToggle()} className="c-tabs__current">
        {currentTab.Name}
      </div>
      <button
        onClick={() => handleToggle()}
        className="c-tabs__toggle"
        aria-controls={Id}
        aria-expanded={this.state.isOpen}
      >
        <span className="c-tabs__toggle__icon" />
      </button>
      <ul id={Id} className="c-tabs__nav" aria-hidden={!isOpen}>
        {tabs}
      </ul>
    </nav>
  );
};

export default withRouter(Tabs);
